export const TOAST_MESSAGES = {
  PGRN_FETCH_FAILED: "Failed to fetch Procurement Goods Receive Notes.",
  PGRN_CREATE_FAILED: "Failed to create PGRN",
  PGRN_FETCH_FAILED_MATERIALS: "Failed to fetch Procurement GRN Materials.",
  PGRN_UPDATE_FAILED: "Failed to update Procurement Goods Receive Notes.",
  PGRN_SUCCESS: "PGRN created successfully!",
  PGRN_ALREADY_ADDED: "This product is already added!",
  PGRN_NO_DATA: "No Details Available",
  PGRN_DELETE: "PGRN Deleted Successfully",
  FAILED_TO_DELETE_PGRN: "Failed to delete PGRN",
  FAILED_TO_FETCH_WAREHOUSES: "Failed to fetch warehouses!",
  UPDATE_PGRN_SUCCESS: "PGRN Updated Successfully",
  UPDATE_PGRN_FAILED: "Failed to update PGRN",
  FILE_DOWNLOAD_SUCCESS: "File downloaded successfully",
  FILE_DOWNLOAD_FAIL: "Failed to download",
  FILE_UPLOAD_SUCCESS: "File uploaded successfully",
  FILE_UPLOAD_FAIL: "Failed to upload file",
  FILE_DELETE_SUCCESS:"File Deleted Successfully",
  FILE_DELETE_FAIL: "Failed to delete file",
  FAILED_TO_LOAD_FILES: "Failed to load files",
};

export const PGRN_MATERIAL_COLUMNS = [
  "receiving_warehouse_name",
  "grn_code",
  "procurement_mrr_code",
  "status",
  "created",
  "created_by",
  "actions",
];

export const PGRN_MATERIAL_LABELS = {
  receiving_warehouse_name: "Requested By (Warehouse)",
  grn_code: "PGRN Code",
  procurement_mrr_code: "PMRR Code",
  status: "Status",
  created: "Raised On",
  created_by: "Requested By",
  actions: "Actions",
};

export const PGRN_STATUS_VALUE_LABELS = [
  { value: "", label: "All" },
  { value: "DRAFT", label: "Draft" },
  { value: "PENDING_APPROVAL", label: "Pending Approval" },
  { value: "APPROVED", label: "Approved" },
  { value: "PENDING_PROCUREMENT_APPROVAL", label: "Pending Procurement Approval" },
  { value: "PENDING_BILLING_APPROVAL", label: "Pending Billing Approval" },
  { value: "BILLING_APPROVED", label: "Billing Approved"},
  { value: "COMPLETED", label: "Completed" },
  { value: "FAILED", label: "Failed" },
];

export const PGRN_STATUS = {
  DRAFT: "DRAFT",
  PENDING_APPROVAL: "PENDING_APPROVAL",
  APPROVED: "APPROVED",
  FAILED: "FAILED",
  PENDING_BILLING_APPROVAL: "PENDING_BILLING_APPROVAL",
  PENDING_PROCUREMENT_APPROVAL: "PENDING_PROCUREMENT_APPROVAL",
  BILLING_APPROVED: "BILLING_APPROVED",
  COMPLETED: "COMPLETED",
};

// helper.js or constants.js

export const getPGRNStatusColor = (status) => {
    switch (status) {
        case "DRAFT":
            return "bg-gray-100 hover:bg-gray-150 transition-colors text-gray-700";
        case "PENDING_APPROVAL":
            return "bg-blue-50 text-blue-500 transition-colors";
        case "PENDING_BILLING_APPROVAL":
            return "bg-yellow-50 text-yellow-500 transition-colors";
        case "BILLING_APPROVED":
        case "APPROVED":
            return "bg-green-50 text-green-500 transition-colors";
        case "FAILED":
            return "bg-red-50 text-red-500";
        case "PENDING_PROCUREMENT_APPROVAL":
            return "bg-cyan-50 text-cyan-500";
        case "COMPLETED":
          return "bg-purple-50 hover:bg-purple-150 transition-colors text-purple-500";
        default:
            return "bg-blue-50 hover:bg-blue-100 transition-colors text-black"; // fallback for unknown status
        }
};

export const MATERIAL_COLUMNS_PGRN = [
  "product_name",
  "quantity",
  "product_condition",
  "comments",
  "actions",
];
export const MATERIAL_LABELS_PGRN = {
  product_name: "Material",
  comments: "Comments",
  product_condition: "Product Condition",
  quantity: "Quantity",
  actions: "Action",
};

export const materialColumns_PGRN = [
  "product_name",
  "quantity",
  "product_condition",
  "comments",
];

export const materialLabels_PGRN = {
  product_name: "Material",
  quantity: "Quantity",
  product_condition: "product_condition",
  comments: "Comments",
};

export const PRODUCT_CONDITION = [
  { value: "GOOD", label: "Good" },
  { value: "DAMAGE", label: "Damage" },
  { value: "PARTIALLY_DAMAGE", label: "Partially Damage" },
];


export const ADMIN_APPROVAL_BUTTONS = [
  {
    label: "Reject",
    status: PGRN_STATUS.FAILED,
    color: "bg-red-500 hover:bg-red-700",
  },
  {
    label: "Approve",
    status: PGRN_STATUS.APPROVED,
    color: "bg-primary hover:bg-blue-700",
  },
];

export const BILLING_COMPLETION_BUTTONS = [
  {
    label: "Mark as Completed",
    status: PGRN_STATUS.BILLING_APPROVED,
    color: "bg-green-600 hover:bg-green-700",
  },
];

export const INCHARGE_SUBMIT_BUTTONS = [
  { label: "Save as Draft", status: PGRN_STATUS.DRAFT },
  { label: "Submit for Approval", status: PGRN_STATUS.PENDING_APPROVAL },
];

